import { defineAction } from '~/prix'
import generalDataSourceGetIntegrationsWithScriptsAction from './dataSourceGetIntegrationsWithScripts.action.json' with { type: 'json' }
import { z } from 'zod'

// Schema para uma routine que pode ter diferentes estratégias
const routineSchema = z.union([
  z.object({
    name: z.string(),
    endpoint: z.string(),
    script: z.string(),
    strategy: z.enum(['bulk', 'incremental']),
    cron: z.union([z.string(), z.array(z.string())]), // Aceita string ou array de strings
    order: z.number(),
  }),
  z.object({
    name: z.string(),
    endpoint: z.string(),
    script: z.string(),
    strategy: z.literal('realtime'),
  }),
])

// Schema para uma integração
const integrationSchema = z.object({
  key: z.string(),
  name: z.string(),
  database: z.unknown(), // Pode ser qualquer estrutura dependendo do data source
  routines: z.record(z.string(), routineSchema), // Mapa de routines por nome
})

// Schema para um download
const downloadSchema = z.object({
  id: z.number(),
  name: z.string(),
  kind: z.string(),
  url: z.string(),
  hash: z.string(),
  version: z.string(),
})

const generalDataSourceGetIntegrationsWithScriptsDefinition = defineAction({
  ...generalDataSourceGetIntegrationsWithScriptsAction,

  input: z.object({
    force: z.boolean().nullish(),
  }),
  output: z.object({
    config: z.object({
      integrations: z.array(integrationSchema),
    }),
    downloads: z.array(downloadSchema),
  }),
})

export default generalDataSourceGetIntegrationsWithScriptsDefinition
